import React, { useRef, useEffect } from 'react';
import Button from '../../components/Button';
import { Link } from 'react-router-dom';
import './css/mixedwebinar.css';
import imh from '../../assets/images/Vid1.png';
import { useQuery } from 'react-query';

const Mixedwebinar = () => {
  const { data, isLoading } = useQuery('fetch-webinar-archive', async () => {
    let data = localStorage;
    const response = await fetch(
      'https://testapi.hendrayfinvest.com/user/academy/webinar/public',
      {
        method: 'GET',
        headers: {
          Authorization: 'Bearer' + ' ',
        },
      }
    ).then((res) => res.json());
    return response.data;
  });
  return (
    <div className="mixedwebinar">
      <h1>Missed the live session? We’ve got you covered</h1>
      <p>
        We record & compiled our previous live recordings incase you missed the
        live sessions.
      </p>
      {data?.map((item, index) => (
        <Webinarcard data={item} key={index} />
      ))}
      {isLoading && <p>Loading</p>}
      <div className="button">
        <Link to="/">
          <Button className="load-button">Load More</Button>
        </Link>
      </div>
    </div>
  );
};

const Webinarcard = ({ data }) => {
  return (
    <div className="course__webinar">
      <div className="course__webinar-header">
        <div>
          <h4 className="webinar-title">{data.title}</h4>
        </div>
        <div className="web__author-name">
          <p>{data.name_of_tutor}</p>
        </div>
      </div>
      {data.webinarrable && (
        <div className="webinar-video">
          <iframe
            width="420"
            height="315"
            src={`${data.webinarrable.url}`}
          ></iframe>
        </div>
      )}{' '}
    </div>
  );
};

export default Mixedwebinar;
